import { DataBean } from "../DataBean";

export class MarketPlace extends DataBean {



    public async getMarketPlaceCatalog(id: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getMarketPlaceCatalog_Number", [id]);
    }

}